import React from "react";
// import ReactDOM from "react-dom";
import { createRoot } from 'react-dom/client';
import { createStore, applyMiddleware, compose, combineReducers } from "redux";
import thunk from "redux-thunk";
import { createLogger } from "redux-logger";
import { Provider } from "react-redux";
import { createBrowserRouter, createRoutesFromElements, RouterProvider } from "react-router-dom";
import { cpadminSlice } from "./store/reducers/cpadminService";
import { authServiceSlice } from "./store/reducers/authServiceSlice";
// import App from "./App/index";
import * as serviceWorker from "./serviceWorker";
import reducer from "./store/reducer";
import config from "./config";
import reducers from "./store/reducers";
import allRoutes from "./App/routes"
import AuthHomeCustomer from "./models/AuthHomeCustomer";
import Auth from "./models/Auth";
import ErrorBoundary from "./App/components/ErrorBoundary";
import './helper/GlobalErrorHandler'; // Initialize global error handling

// import main scss
import '@splidejs/splide/dist/css/splide.min.css';
import './assets/css/style.scss';
import './assets/scss/index.scss';

const logger = createLogger();
const allStoreEnhancers = compose(
    // applyMiddleware(thunk),
    applyMiddleware(thunk, cpadminSlice.middleware, authServiceSlice.middleware, logger),
    window.devToolsExtension ? window.devToolsExtension() : (f) => f
);
const store = createStore(
    combineReducers({
        reducer,
        ...reducers,
    }),
    allStoreEnhancers
);

const router = createBrowserRouter(
    createRoutesFromElements(
        allRoutes
    ),
    { basename: config.basename }
);

export const PORTAL_INSTANCE = {
    isHomeCustomer: false,
    cId: 0,
    pId: 0,
    pkey: 'cpUInfo_',
    hkey: 'cpHomeUInfo_',
    ekey: '_',
    authInst: Auth,
};

(() => {
    let SSOAuthCallbackUrl = `${window.location.protocol}//${window.location.host}/home/samlredirect/`
    let isSSOAuthCallbackUrl = (window.location.href.indexOf(SSOAuthCallbackUrl) === 0)
    let cpHomeCustURL = `${window.location.protocol}//${window.location.host}/home-customer`
    let isHomeCustomer = (window.location.href.indexOf(cpHomeCustURL) === 0)
    //
    const search = window.location.search;
    const params = new URLSearchParams(search)
    let cId = parseInt(params.get('cId') || '0')
    let pId = parseInt(params.get('pId') || '0')
    if (isSSOAuthCallbackUrl) {
        let pathParams = window.location.href.match(/\/client\/([0-9]+)\/portal\/([0-9]+)/)
        if (pathParams && pathParams.length === 3) {
            cId = parseInt(pathParams[1] || '0')
            pId = parseInt(pathParams[2] || '0')
        }
    }

    Object.assign(PORTAL_INSTANCE, {
        isHomeCustomer, cId, pId,
        ekey: `${isHomeCustomer ? PORTAL_INSTANCE.hkey : PORTAL_INSTANCE.pkey}${pId}_`
    })

    PORTAL_INSTANCE.authInst = isHomeCustomer ? AuthHomeCustomer : Auth
    if (isHomeCustomer) {
        console.log('Loading cp home data')
    } else {
        console.log('Loading cp data')
    }

    PORTAL_INSTANCE.authInst.initialize()
})()

console.log('PORTAL_INSTANCE', PORTAL_INSTANCE)

const app = (
    <ErrorBoundary>
        <Provider store={store}>
            {/* <BrowserRouter basename={config.basename}> */}
            {/* basename="/datta-able" */}
            {/* <App /> */}
            <RouterProvider router={router} />
            {/* </BrowserRouter> */}
        </Provider>
    </ErrorBoundary>
);
const root = createRoot(document.getElementById("root"));
root.render(app);
// ReactDOM.render(app, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
export { store };
